import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import UbicationTypeService from "../../../../services/ubicationType.service";
import { useCallback } from "react";
import BodyService from "../../../../services/body.service";
import { useEffect } from "react";
import { Alert, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UbicationTypeForm from "../../../../components/forms/configuration/UbicationTypeForm";
import UserPermissionService from "../../../../services/userPermission.service";

const UbicationTypeDetails = () => {
    const params = useParams();

    const navigate = useNavigate();

    const { t } = useTranslation();

    const [ubicationType, setUbicationType] = useState();

    const [translations, setTranslations] = useState([]);

    const [title, setTitle] = useState("");

    const [permissions, setPermissions] = useState({});

    const [success, setSuccess] = useState({
        update: false,
        email: false,
    });

    const [errors, setErrors] = useState({
        update: false,
    });

    const getUbicationType = useCallback(async (id) => {
        try {
            const data = await UbicationTypeService.getById(id);
            setUbicationType(data);
            setTitle(data.ubicationType["es"].value);
        } catch (error) {
            navigate("/configuration/ubication-type");
        }
    }, [navigate]);

    const updateUbicationType = async (data) => {
        setErrors({ ...errors, update: false });
        setSuccess({ ...success, update: false });
        try {
            await UbicationTypeService.update(params.id, data);
            getUbicationType(params.id);
            setSuccess({ ...success, update: true });
        } catch (e) {
            setErrors({ ...errors, update: true });
        }
    };


    const getEmptyTranslations = async () => {
        const data = await BodyService.getEmptyTranslations();
        setTranslations(data);
    };

    const getPermissions = async () => {
        try {
            const data = await UserPermissionService.getPermissionsByConnected();
            setPermissions(data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        const loadData = async () => {
            await getPermissions();
        }

        loadData();
    }, []);

    useEffect(() => {
        getUbicationType(params.id);
        getEmptyTranslations();
    }, [getUbicationType, params.id]);

    return (
        <>
            <Alert variant={"success"} show={success.update} dismissible onClose={() => setSuccess({ ...success, update: false })}>
                {t('ubicationType.success.update')}
            </Alert>

            <Alert variant={"danger"} show={errors.update} dismissible onClose={() => setErrors({ ...errors, update: false })}>
                {t('ubicationType.error.update')}
            </Alert>

            <div className={"d-flex justify-content-between my-3"}>
                <Link to="/configuration/ubication-type" className={"previous round rounded-circle text-decoration-none"}
                    title={t('general.back')}>
                    <FontAwesomeIcon icon={"chevron-left"} className={"mt-2 me-2"} />
                    <span>{t('ubicationType.title')}</span>
                </Link>
            </div>
            <Card>
                <Card.Header className={"py-3"}>
                    <h1 className={"h3 mb-0 text-gray-800 card-title text-capitalize"}>{title}</h1>
                </Card.Header>
                <Card.Body>
                    <UbicationTypeForm onSubmit={updateUbicationType} ubicationType={ubicationType} translations={translations} permissions={permissions} details />
                </Card.Body>
            </Card>
        </>
    );
};

export default UbicationTypeDetails;